import { RedesignRating, useFeedbackSurvey } from '@app/services/hooks/feedbackSurvey/useFeedbackSurvey';
import { isDefined, isNull } from '@app/utils/is';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '../various/Modal';

import { SurveyOpinionForm } from './SurveyOpinionForm';
import { SurveyRating } from './SurveyRating';

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
}

export const RedesignExitSurveyModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation(['common', 'onboarding']);
  const [selectedRating, setSelectedRating] = React.useState<Nullable<RedesignRating>>(null);
  const { submitSurvey, isSubmittingSurvey } = useFeedbackSurvey();

  const handleClose = () => {
    if (!isDefined(selectedRating)) {
      onClose();

      return;
    }

    submitSurvey({ callback: onClose, rating: selectedRating });
  };

  const handleSubmit = (comment: string) => {
    if (!isDefined(selectedRating)) {
      onClose();

      return;
    }

    submitSurvey({ callback: onClose, comment, rating: selectedRating });
  };

  const handleModalClosed = () => {
    setSelectedRating(null);
  };

  return (
    <Modal
      title={t('onboarding:survey.redesign_change_rating_title')}
      description={selectedRating !== null && t('onboarding:survey.feedback_description')}
      isOpen={isOpen}
      shouldCloseOnLocationChange={false}
      size="medium"
      onClose={handleClose}
      modalClosedCallback={handleModalClosed}
    >
      {isNull(selectedRating) ?
        <SurveyRating onRatingSelect={setSelectedRating} onCancel={handleClose} isLoading={isSubmittingSurvey} />
      : <SurveyOpinionForm onCancel={handleClose} onSubmit={handleSubmit} isLoading={isSubmittingSurvey} />}
    </Modal>
  );
};
